<div *ngIf="!isWebAppLink" class="lm-card-view" [ngClass]="cardViewClasses">
  <ng-container *ngIf="hasImage || fromHomeSuite">
    <div class="lm-card-image" [ngClass]="cardImageClasses">
      <img *ngIf="hasImage" class="avatar" [ngClass]="{'large': isLargeScale, 'smallImg': !isLargeScale, 'noFloat' : isParagraph }" src="{{imageUrl}}" alt="" (click)="onClickEvent($event)"/>
      <!-- decorative image, alt can be left blank since there's a title span below -->
    </div>
  </ng-container>
  <div class="lm-card-content" [ngClass]="{'titlePadding': isParagraph }">
    <div class="lm-card-title" [ngClass]="{'adjustTitle': !isLargeScale }" >
      <a soho-hyperlink
         [attr.tabindex]="isInAccessibilityMode ? 0 : null"
         [style.width]="showBarCode ? '80%' : '100%'"
         soho-tooltip title="{{title | formatMessageRule:true:title:model:specFields}}" [placement]="'offset'"
         (fieldEvent)="onFieldEvent($event)"
         (keydown.enter)="onClickEvent($event)"
         (click)="onClickEvent($event)">
        <span [ngClass]="{'paraTitle': isParagraph }">{{title | formatMessageRule:true:title:model:specFields}}</span>
      </a>
      <button *ngIf="showBarCode"
        soho-button="icon"
        icon="barcode"
        id="barcode-id"
        (click)="onBarCodeClick()">
      </button>
    </div>
    <ng-container *ngIf="!!description.resourceValue || fromHomeSuite">
      <div *ngIf="!isParagraph" class="lm-card-flex">
        <div class="lm-column">
          <p *ngIf="isLargeScale" soho-tooltip #cardDescription
              class="lm-card-description"
              (mouseenter)="showToolTip(cardDescription)"
              title="{{isMultiLineDescription ? (description | formatMessageRule:true:description:model:specFields) : ''}}"
          >{{description | formatMessageRule:true:description:model:specFields}}</p>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<div *ngIf="isWebAppLink" class="lm-card-view" (click)="onClickEvent($event)" [style.cursor]="'pointer'" [ngClass]="cardViewClasses">
  <ng-container *ngIf="hasImage || fromHomeSuite">
    <div class="lm-card-image" [ngClass]="cardImageClasses">
      <!-- Added an empty alt="" to indicate the image is decorative/does not convey meaningful information. -->
      <img class="avatar large" alt="" *ngIf="hasImage" src="{{imageUrl}}"/>
    </div>
  </ng-container>
  <div class="lm-card-content">
    <div class="lm-card-title">
      <a soho-hyperlink
         [attr.tabindex]="isInAccessibilityMode ? 0 : null"
         soho-tooltip title="{{title | formatMessageRule:true:title:model:specFields}}"
         (keydown.enter)="onClickEvent($event)"
         (fieldEvent)="onFieldEvent($event)">
        <span>{{title | formatMessageRule:true:title:model:specFields}}</span>
      </a>
    </div>
    <ng-container *ngIf="!!description || fromHomeSuite">
      <div class="lm-card-flex">
        <div class="lm-column">
          <p soho-tooltip #cardDescription
           (mouseenter)="showToolTip(cardDescription)"
           title="{{isMultiLineDescription ? (description | formatMessageRule:true:description:model:specFields) : ''}}">
           {{description | formatMessageRule:true:description:model:specFields}}</p>
        </div>
      </div>
    </ng-container>

    <ng-template [ngIf]="isWebAppLink">
      <button
          soho-menu-button
          hideMenuArrow=true
          class="btn-actions"
          icon="more"
          attachToBody="'true'"
          removeOnDestroy="'true'"
          [style.visibility]="this.lmContextService.inMingleWidget() ? 'hidden' : 'visible'"
      >
        <span class="audible">{{'More' | translate}} - {{title | formatMessageRule:true:title:model:specFields}}</span>
      </button>
      <div class="popupmenu-wrapper bottom" role="application" aria-hidden="true">
        <ul class="popupmenu is-selectable"  id="{{webAppName}}">
          <li class="btn">
            <a (keydown.space)="onPreferredMenuEvent()" (click)="onPreferredMenuEvent()" attr.aria-label="{{'SetPreferred' | translate}}">{{setPreferred}}</a>
          </li>
        </ul>
      </div>
    </ng-template>
  </div>
  <span *ngIf="isPreferred"><img class="preferred" src="./lib/landmark/images/defaultPage.png" title="Preferred" alt=""></span>
</div>
